import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {resolveFinancialHealthIndicatorGroups} from './resolvers/financial-health-indicator-groups.resolver.service';
import {map} from 'rxjs/operators';
import {FinancialHealthIndicatorRouteParameters} from './financial-health-indicator-route-parameters';

/**
 * Determine if Indicator Code is valid
 *  Check indicator code route parameter against indicators. If the indicator is in an indicator group for this mcag,
 *  year range, pass. If not, fail and navigate to first indicator in the indicator groups list. If no indicators, pass and
 *  navigate to 'not found' as indicator param on page (used to define null indicator).
 *
 * @param route
 */
export const financialHealthIndicatorGuard: CanActivateFn = (route) => {
	const router = inject(Router);
	const indicatorCode= route.paramMap.get(FinancialHealthIndicatorRouteParameters.indicatorCode);
	const mcag= route.paramMap.get(FinancialHealthIndicatorRouteParameters.mcag);
	return resolveFinancialHealthIndicatorGroups(route).pipe(indicatorGroups => {
		return indicatorGroups.pipe(map(indicatorGroups => {
			const indicators = indicatorGroups.map((indicatorGroup) => indicatorGroup.indicators).flat();
			const foundIndicator = indicators.find((indicator) => indicator.instanceCode === indicatorCode);

			const optionalParams : { [key: string]: string | null; } = {};
			route.paramMap.keys.forEach(key => {
				if (key !== FinancialHealthIndicatorRouteParameters.indicatorCode && key !== FinancialHealthIndicatorRouteParameters.mcag) {
					optionalParams[key] = route.paramMap.get(key);
				}
			});

			if (foundIndicator) {
				return true;
			} else if (indicators.length > 0) {
				router.navigate(['.', 'explore', 'government', mcag, 'health', indicators[0].instanceCode, optionalParams]).then();
				return false;
			} else if (indicatorCode === 'not-found') {
				return true;
			} else {
				router.navigate(['.', 'explore', 'government', mcag, 'health', 'not-found', optionalParams]).then();
				return false;
			}
		}));
	});
}
